import React from "react";
import { useEffect } from 'react';
import { useSelector } from "react-redux";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { styled } from '@material-ui/core/styles';

const AntTabs = styled(Tabs)({
    minHeight: '24px',
   '& .MuiTabs-indicator': {
        backgroundColor: '#1890ff',
    },
});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    marginRight: theme.spacing(1),
    color: 'rgba(0, 0, 0, 0.85)',
    minHeight: '24px',
    '&:hover': {
        color: '#40a9ff',
        opacity: 1,
    },
}));

export default function GridTab(props) {
    const [value, setValue] = React.useState(props.tabvalue);
    const tabs = useSelector(state => state.form.listtabs);
    const tabvalue = useSelector(state => state.form.gridtab);

    useEffect(() => {
        tabChange("0");
    }, [tabvalue]);


    function onChange(e,newValue) {
        if (props.api.getDisplayedRowCount() !== 0) {
            let msg = "表示中の内容は破棄されます。よろしいですか？";
            props.fnc.current.confmsg(msg, () => tabChange(newValue));
        } else {
            tabChange(newValue);
        }
    }
    function tabChange(newValue) {
        setValue(newValue);
        props.tabChange(newValue, value);
    }

    if (tabs === undefined) return null;
    return (
        <div style={{ width: '100%' }}>
            <AntTabs
            value={value}
            onChange={onChange}
            textColor="primary"
            variant="scrollable"
                scrollButtons="auto"
            >
            {tabs.map(tab => (
                <AntTab label={tab.label} value={tab.value}   />
            ))}
            </AntTabs>
    </div>
    );
}